import React, { createContext } from 'react';

export const CategoriasContext = createContext();